import React from 'react';
import TableArea from './TableArea';

function Table() {
    return (
        <div className="Table">
            <TableArea />
        </div>
    );
}

export default Table;